/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Tools_Compare_TitleInputs */

const en_directory_tools_compare_title = /** @type {(inputs: Directory_Tools_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare directories`)
};

const zh_directory_tools_compare_title = /** @type {(inputs: Directory_Tools_Compare_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比目录`)
};

/**
* | output |
* | --- |
* | "Compare directories" |
*
* @param {Directory_Tools_Compare_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_tools_compare_title = /** @type {((inputs?: Directory_Tools_Compare_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Tools_Compare_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_tools_compare_title(inputs)
	return zh_directory_tools_compare_title(inputs)
});
export { directory_tools_compare_title as "directory.tools.compare.title" }